;(function () {
  'use strict'

  angular
    .module('contrast.access-control-settings')
    .factory('AccessControlSettingsService', [
      '$q',
      'logger',
      'preferencesService',
      'OrganizationFactory',
      'ErrorService',
      'AvailableLanguagesService',
      'PREFERENCE_PROPERTIES'
    ])
})()
